import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { dateToISOStringPreprocessor } from '../../../utils/date-to-iso-string-preprocessor';
import { ignoreData } from '../../../utils/ignore-data';
import { parseRequestSchema } from '../../../utils/parse-request-schema';
import { authwsEnvironment } from '../authws-environment';
import { accountProductRelationshipSchema } from '../schemas/account-product-relationship.schema';

const requestSchema = accountProductRelationshipSchema
  .omit({
    manageOwnAPIKeys: true,
    phone: true,
  })
  .partial()
  .required({ accountState: true })
  .extend({
    product: z.string().min(1),
    accountId: z.number().min(1),
  });

/**
 * Assigns a Trimble Maps product to an account
 * @param request.product Trimble Maps product
 * @param request.accountId Id of the Account to assign the product to
 * @param request.accountState State of the Account
 */
export function postProductAssign(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).productAssignUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: parseRequestSchema(
        requestSchema.extend({
          expirationDate: dateToISOStringPreprocessor().nullable().optional(),
        }),
        request
      ),
    })
  ).pipe(ignoreData());
}
